/** Floating point equality check */
export function floatEqual(x: number, y: number) {
    return Math.abs(x - y) < 2 ** -3
}

export function randomize(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min
}

/** Gets a random element from an array */
export function sample<T>(arr: T[]) {
    const { length } = arr
    return length > 0 ? arr[randomize(0, length - 1)] : undefined
}
